import { AppButton } from '@/shared/ui/button'
import { useStyles } from './styles'
import { $userLanguage } from '@/entities/user'
import { useUnit } from 'effector-react'
import { lang } from '@/shared/constants/lang'
import { $innerWidth } from '@/entities/navigation/store'
import { NewPlatformMark } from '@/shared/ui/newPlatformMark'
import { PlatformType } from '@/entities/platforms/types.ts'

export const PlatformListItem = (props: PlatformType) => {
  const { name, status, icon, onClick, isMock, isBeta } = props
  const { classes } = useStyles()
  const innerWidth = useUnit($innerWidth)

  const userLang = useUnit($userLanguage)
  const texts = lang[userLang].pages.main.statuses

  if (isMock) {
    return (
      <div
        style={{
          width: '1px',
          height: '1px',
        }}
      ></div>
    )
  }

  return (
    <AppButton
      onClick={onClick}
      disabled={status == 'Soon' || status === 'Legacy'}
      data-status={status}
      classes={{ root: classes.root }}
      style={{
        willChange: 'transform',
        backfaceVisibility: 'hidden',
        transform: 'translate3d(0, 0, 0)',
        width: innerWidth / 2.5,
        cursor: 'default',
        aspectRatio: '1/1',
        boxShadow: 'none',
        marginLeft: '5vw',
      }}
    >
      <span className={classes.dragHelper} data-disabled={status == 'Soon' || status === 'Legacy'} />
      <div className={classes.imageWrapper}>
        <img
          style={{
            willChange: 'transform',
            backfaceVisibility: 'hidden',
            transform: 'translate3d(0, 0, 0)',
          }}
          className={classes.img}
          src={icon}
          alt={name}
        />
        {status != 'Soon' && <img src="/assets/svg/arrow.svg" alt="" />}
      </div>

      <div
        className={classes.infoWraper}
        style={{
          willChange: 'transform',
          backfaceVisibility: 'hidden',
          transform: 'translate3d(0, 0, 0)',
        }}
      >
        <div className={classes.nameWrapper}>
          <span className={classes.name}>{name}</span>
          {isBeta && <NewPlatformMark />}
        </div>

        <div data-status={status} className={classes.statusWrapper}>
          <div className={classes.dot}></div>
          <p data-status={status} className={classes.status}>
            {texts[status]}
          </p>
        </div>
      </div>
    </AppButton>
  )
}
